export const apiConstants = {
  semifinisheds: '/semifinisheds',
};
